import { tabIDToType } from "@store/minersSelect/actionTypes";
import { RootDispatch, RootState } from "@store";
import {
  clearRefreshingMiners,
  setMiners,
  setRefreshingMiners,
} from "@store/storedMiners/actions";
import { useMTFilters } from "@utils/hooks/useFilters";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useGetMinerList from "@utils/hooks/useGetMinerList";
import { fillNamedTotals } from "@services/http/responses/BaseResponse";

export const useRefreshMiners = () => {
  const dispatch = useDispatch() as RootDispatch;
  const filters = useMTFilters();
  const {getMinerList} = useGetMinerList();
  const tab = useSelector(
    (state: RootState) => tabIDToType(state.minersSelect.tab)
  );
  const options = useSelector((store: RootState) => ({
    page: store.minersTable.Page || 1,
    pageSize: store.minersTable.PageSize || 20,
    sort: store.minersTable.sort || [0, 0],
  }));
  const [loading, setLoading] = useState(false);
  //useEffect(() => {console.log("2 TAB:", tab)}, [tab]);

  return {
    loading,

    refresher: async () => {
      try {
        setLoading(true);

        const offset = (options.page - 1) * options.pageSize;
        const filtersForRefresh = filters.values;
        const limit = options.pageSize;
        const filter = filtersForRefresh;
        const sort = options.sort[0];
        const dir = options.sort[1];

        const res = await getMinerList(
          offset,
          limit,
          filter,
          sort,
          dir,
          tab,
        );

        if (!res) return;
        dispatch(
          setMiners(res.Records, tab === "unknown", res.Total, fillNamedTotals(res.Namedtotals))
        );
        dispatch(setRefreshingMiners());
      } finally {
        setLoading(false);
        dispatch(clearRefreshingMiners());
      }
    },
  };
};
